import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ApproverService } from '../core/services/approver.service';


@Component({
  selector: 'app-approverconformation',
  templateUrl: './approverconformation.component.html',
  styleUrls: ['./approverconformation.component.scss']
})
export class ApproverconformationComponent implements OnInit {
  popupName:any;
  approver='approverPage';
  chatData={};
  constructor(@Inject(MAT_DIALOG_DATA) public data,
  @Inject(DOCUMENT) private document: Document,
  private approverService:ApproverService,
 
  public dialogRef: MatDialogRef<ApproverconformationComponent>) { }
  comments:any='';
  ngOnInit() {  
    this.popupName=this.data.name;
    this.loadCiscoStyles('client-cisco.css');
    if(this.data.name=='chatModal'){
      this.chatData = {
        fileData: {...this.data}
      };
    }
  }
  loadCiscoStyles(styleName) {
    const head = this.document.getElementsByTagName('head')[0];
    const styleLink = this.document.createElement('link');
    styleLink.rel = 'stylesheet';
    styleLink.classList.add('cisco_styles')
    styleLink.href = styleName;
    head.appendChild(styleLink);
  };
  closeDialog(){
    this.dialogRef.close()
  }
  updateStatus(status){
    let req='?userChallengeId='+this.data.approverData.userChallengeId+'&fileId='+this.data.approverData.fileId+'&status='+status+'&comments='+this.comments
    this.approverService.updateStatus(req).subscribe((res)=>{
      this.dialogRef.close('true')
     
    })
  }
}
